module.exports = __webpack_public_path__ + "img/audi-event4.a6fde537.jpg";